import { gql } from "graphql-request";

export const ActiveWebSubscriptionPrice = gql`
  query ActiveWebSubscriptionPrice {
    activeWebSubscriptionPrice {
      productIdentifier
      productName
      formattedPrice
      amount
      currency
      interval
      intervalCount
    }
  }
`;

export const SubscriptionPauseState = gql`
  query SubscriptionPauseState($firebaseID: String!) {
    user(firebaseUserId: $firebaseID) {
      id
      isPaused
      pauseResumesAt
    }
  }
`;

export const PauseWebSubscription = gql`
  mutation PauseWebSubscription($input: PauseWebSubscriptionInput!) {
    pauseWebSubscription(input: $input) {
      success
      resumesAt
    }
  }
`;

export const CancelWebSubscription = gql`
  mutation CancelWebSubscription($input: CancelWebSubscriptionInput!) {
    cancelWebSubscription(input: $input) {
      success
    }
  }
`;

export const ResumeWebSubscription = gql`
  mutation ResumeWebSubscription($input: ResumeWebSubscriptionInput!) {
    resumeWebSubscription(input: $input) {
      success
    }
  }
`;
